import * as React from "react"
import {
    BookOpen, FileText, SquarePlus, Database, ScanFace, LayoutDashboardIcon, Building, Files
} from "lucide-react"

import {NavMain} from "@/components/nav-main"
import {NavProjects} from "@/components/nav-projects"
import {NavUser} from "@/components/nav-user"
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarGroupContent,
    SidebarHeader, SidebarMenu,
    SidebarMenuButton,
    SidebarRail,
} from "@/components/ui/sidebar"
import axios from "axios";
import {NavLink, useNavigate} from "react-router";
import {useEffect} from "react";
import usePermission from "@/components/permissions/usePermission.ts";
import {Branding} from "@/components/branding.tsx";


export function AppSidebar({...props}: React.ComponentProps<typeof Sidebar>) {
    const navigate = useNavigate();

    function createDocument() {
        axios.post(`/api/documents`).then(res => {
            navigate(`/documents/${res.data.id}/edit`)
        })
    }

    const [, canReadUsers] = usePermission("user.any");

    const data = {
        navMain: [
            {
                title: "Tanulmányok",
                url: "#",
                icon: BookOpen,
                isActive: true,
                items: [
                    {
                        icon: FileText,
                        title: "Dokumentumaim",
                        url: "/documents",
                    },
                    {
                        icon: SquarePlus,
                        title: "Új tanulmány",
                        onClick: createDocument
                    }
                ],
            },
            {
                title: "Adatbázis",
                url: "#",
                icon: Database,
                items: [
                    {
                        icon: Building,
                        title: "Cégek",
                        url: "/database/companies"
                    },
                    canReadUsers ? {
                        icon: ScanFace,
                        title: "Felhasználók",
                        url: "/database/users",
                    } : undefined,
                    {
                        icon: Files,
                        title: "Dokumentumtár",
                        url: "/database/files",
                    },
                ],
            },
        ],
    }

    const [documents, setDocuments] = React.useState([]);

    useEffect(() => {
        axios.get("/api/documents").then((res) => {
            setDocuments(res.data?.data?.slice(0, 4))
        })
    }, []);

    return (
        <Sidebar collapsible="icon" {...props}>
            <SidebarHeader>
                <Branding/>
            </SidebarHeader>
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            <SidebarMenuButton asChild>
                                <NavLink to={"/"}>
                                    <LayoutDashboardIcon/>
                                    <span>Vezérlőpult</span>
                                </NavLink>

                            </SidebarMenuButton>
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
                <NavMain items={data.navMain}/>
                <NavProjects projects={documents}/>
            </SidebarContent>
            <SidebarFooter>
                <NavUser/>
            </SidebarFooter>
            <SidebarRail/>
        </Sidebar>
    )
}
